var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rectangle-button",class:{
        active: _vm.configuratorStore.config.fixture === _vm.fixtureLevel,
        ia: _vm.isIA(_vm.fixtureLevel),
        unavailable: _vm.isUnavailable(_vm.fixtureLevel),
    },on:{"click":function($event){return _vm.onButtonClicked(_vm.fixtureLevel)}}},[_c('span',{staticClass:"ctn"},[_vm._v(_vm._s(_vm.getLevelName(_vm.fixtureLevel)))]),_c('CircleTag',{attrs:{"tagtype":"checked"}}),_c('CircleTag',{attrs:{"tagtype":"flash"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }